// extracted by mini-css-extract-plugin
export default {"customCenter":"ConfirmScreen_customCenter__l0tok"};